import api from "@/services/api";

export const state = {
  entities: [],
  entity: {},
};

export const mutations = {
  INIT_STATES(state, payload) {
    state.entities = payload;
  },
  INIT_STATE(state, payload) {
    state.entity = payload;
  },
};

export const actions = {
  getEntities({ commit }, payload) {
    return api.getStates(payload).then((response) => {
      commit("INIT_STATES", response.data.data);

      if (!payload.retrieveAll) commit("pager/INIT_PAGER", response.data.pagedResult, { root: true });
    });
  },
  getEntityById({ commit }, payload) {
    return api.getStateById(payload).then((response) => {
      commit("INIT_STATE", response.data.data);
    });
  },
};

export const getters = {
  getEntities: (state) => state.entities,
  getEntity: (state) => state.entity,
};
